import { defineAction } from '~/prix'
import actionJson from './roadMaintenanceDocumentUpdate.action.json' with { type: 'json' }
import { roadMaintenanceDocumentObject } from '../roadMaintenanceDocumentObject'
import { z } from 'zod'

const definition = defineAction({
  ...actionJson,
  input: roadMaintenanceDocumentObject
    .pick({ id: true, fileName: true, mimeType: true, status: true })
    .partial()
    .required({ id: true }),
  output: roadMaintenanceDocumentObject,
})

export default definition
